<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-batch-adjustment`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 32a1 1 0 011 1v7h7a1 1 0 011 1v2a1 1 0 01-1 1H6a2 2 0 01-2-2v-9a1 1 0 011-1h2zm36 0a1 1 0 011 1v9a2 2 0 01-2 2h-9a1 1 0 01-1-1v-2a1 1 0 011-1h7v-7a1 1 0 011-1h2zm-8.615-14.707l1.414 1.414a1 1 0 010 1.414l-12.02 12.021a1 1 0 01-1.32.083l-.095-.083-7.071-7.07a1 1 0 010-1.415l1.414-1.414a1 1 0 011.414 0l4.95 4.949 9.9-9.9a1 1 0 011.414 0zM15 4a1 1 0 011 1v2a1 1 0 01-1 1H8v7a1 1 0 01-1 1H5a1 1 0 01-1-1V6a2 2 0 012-2h9zm27 0a2 2 0 012 2v9a1 1 0 01-1 1h-2a1 1 0 01-1-1V8h-7a1 1 0 01-1-1V5a1 1 0 011-1h9z"/></svg>
</template>
<script>

export default {
  name: 'IconBatchAdjustment',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
